import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import { Player } from "video-react";
import "./turor-panel-class-view.css";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
const MyClassesView = (props) => {
  const navigate = useNavigate();
  const [accept, setAccept] = React.useState(false);
  const TableData = [
    {
      id: "1",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "2",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "3",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "4",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "5",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "6",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "7",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
    {
      id: "8",
      name: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
              <div>
                <Player
                  className="play"
                  playsInline
                  poster={ProfileImg}
                  src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                />
              </div>
            </Grid>
            <Grid item xl={7} lg={7} md={7} sm={12} xs={12}>
              <div>
                <div className="live-class-details-heading-main">
                  <p className="live-class-details-heading">Maths Class</p>
                </div>
                <p className="live-class-details-description">
                  Integer sed lectus et sem porttitor vulputate. Integer a felis
                  est. Fusce sodales mollis risus, et tempus enim. Curabitur eu
                  turpis imperdiet.
                </p>
                <div className="live-class-details-tag-date-main">
                  <div className="live-class-details-tag-main">
                    <p className="live-class-details-tag-title">Maths</p>
                  </div>
                  <div className="live-class-details-date-main">
                    <p className="live-class-details-date-heading">
                      Date & time:
                    </p>
                    <p className="live-class-details-date">
                      JAN 31, 2022, 08:00 AM
                    </p>
                  </div>
                </div>
                {!accept ? (
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                      <Button
                        className="tutor-panel-class-reject-button"
                        variant="text"
                        onClick={() => navigate(-1)}
                      >
                        Reject
                      </Button>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                      <Button
                        className="tutor-panel-class-accept-button"
                        variant="text"
                        onClick={() => setAccept(true)}
                      >
                        Accept
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                      <Button
                        className="tutor-panel-class-start-button"
                        variant="text"
                        onClick={() => navigate("/tutor-panel/my-classes/live")}
                      >
                        Start Class
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Number of students</p>
          </div>
          <div className="table-data-container">
            <table>
              <tr>
                <th className="my-classes-table-id-heading">ID</th>
                <th className="my-classes-table-student-name-heading">
                  Students Name
                </th>
                <th className="my-classes-table-country-heading">country</th>
                <th className="my-classes-table-state-heading">State</th>
                <th className="my-classes-table-city-heading">City</th>
                <th className="my-classes-table-email-heading">Email</th>
                <th className="my-classes-table-mob-num-heading">Phone</th>
              </tr>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-data">{tableValue.id}</td>
                    <td className="table-data">{tableValue.name}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.city}</td>
                    <td className="table-email-data">{tableValue.email}</td>
                    <td className="table-data">{tableValue.phone}</td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default MyClassesView;
